import { useContext } from 'react';
import AppContext from '../context/AppContext';

export default () => useContext(AppContext);
